import React, { useState } from 'react';
import { IconButton, makeStyles, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button } from '@material-ui/core';
import logo from "../../img/member_icon.png"
import ThumbUpOutlinedIcon from '@material-ui/icons/ThumbUpOutlined';

const useStyles = makeStyles(theme => ({
    board: {
        width: "270px",
        height: "300px",
        //position: "relative",
        //  display: "inline-block",
        backgroundColor: "#ffffff",
        borderRadius: "20px",
        //boxShadow: "0.05px 0.01px 1px",
        overflow: "hidden",
        margin: "1%",
        transition: "all 0.2s ease-in-out",
        "@media (max-width: 770px)": {
            width: "45%",
            height: "220px",
            margin: "0.8%",
        },
        "&:hover": {
            cursor: "pointer",
            transform: "scale(1.1)",
            boxShadow: "0 0 11px rgba(33,33,33,.2)"

        }
    },
    header_box: {
        width: "100%",
        display: "flex",
        margin: "6% 0px 6% 0px",
        alignItems: "center",
        justifyContent: "space-around",
    },

    icon: {
        width: "45px",
        height: "45px",
        background: "#f3f3f3",
        borderRadius: "100%",
        textAlign: "center",
        "& img": {
            // verticalAlign: "middle",
            marginTop: "13px"
        }
    },
    name: {
        fontSize: "16px",
        fontWeight: 500,
    },
    body_box: {
        display: "block",
        padding: "0px 25px"


    },
    date_box: {
        textAlign: "right",
        "@media (max-width:400px)": {
            width: "40%"
        }
    },
    title: {
        fontSize: "18px",
        fontWeight: 500,
        lineHeight: "30px",
        width: "100%",
        minHeight: "60px",
        display: "-webkit-box box",
        overflow: "hidden",
        textOverflow: "ellipsis",
        wordBreak: "break-all",
        WebkitLineClamp: "2",
        height: "60px",
        margin: "23px 0px 15px",
        "@media (max-width: 770px)": {
            fontSize: "16px",
            lineHeight: "20px",
            minHeight: "40px",
            height: "40px",
            margin: "15px 0px 10px",
        }
    },
    content: {
        display: "-webkit-box -ms-flexbox box",
        width: "100%",
        height: "60px",
        overflow: "hidden",
        color: "#999999",
        fontSize: "14px",
        textOverflow: "ellipsis",
        lineHeight: "20px",
        verticalAlign: "top",
        wordBreak: "break-all",
        WebkitLineClamp: 3,
        "@media (max-width: 770px)": {
            fontSize: "12px",
            lineHeight: "16px",
            height: "46px",
            WebkitLineClamp: 2,
        }


    },
    footer_box: {
        borderTop: "1px solid #ddd",
        margin: "15px 10px 5px",
        textAlign: "center",
        "@media(max-width:770px)": {
            margin: "5px 10px",
        }
    },
}));


const Tip = ({ title, content, date, author, likes, liked_users, category }) => {

    const [open, setOpen] = useState(false);


    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const styles = useStyles();

    return (
        <>
            <div className={styles.board} onClick={handleClickOpen}>
                <div className={styles.header_box}>
                    <div className={styles.icon}>
                        <img src={logo} alt="logo" />
                    </div>
                    <div className={styles.name}>
                        {author}
                    </div>
                    <div className={styles.date_box}>
                    </div>
                </div>
                <div className={styles.body_box}>
                    <div className={styles.title}>
                        {title}
                    </div>
                    <div className={styles.content}>
                        {content}
                    </div>
                </div>
                <div className={styles.footer_box}>
                    <IconButton color="primary">
                        <ThumbUpOutlinedIcon />
                        {likes}
                    </IconButton>
                </div>

            </div>
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>
                    {title}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {date}/{author}
                    </DialogContentText>
                    <DialogContentText color="primary">
                        {category}
                    </DialogContentText>
                    <DialogContentText>
                        {content}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button color="primary" onClick={handleClose}>
                        닫기
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default React.memo(Tip);